<template>
    <div class="qrcode">
        <div class="scan-title">扫码验券</div>
        <div id="reader"></div>
        <div class="scan-input" @click="inputCode">输入验券码</div>
        <van-dialog v-model="show" title="输入验券码" show-cancel-button @confirm="dialogConfirm">
            <div class="c2">
                <van-field v-model="params.verificationCode" style="height: 100%" placeholder="请输入验券码" />
            </div>
        </van-dialog>
    </div>
</template>

<script>
import { Html5Qrcode } from 'html5-qrcode';
import { reqWriteOff } from '../api/merchant';
export default {
    beforeRouteEnter(to, from, next) {
        console.log(from);
        if (from.name === 'Index') {
            next();
            return;
        } else {
            next((vm) => {
                vm.$route.meta.backPath = 'back';
                console.log(vm.$route.meta);
            });
        }
        next();
    },
    data() {
        return {
            show: false,
            path: '',
            html5QrCode: null,
            params: {
                phone: '',
                verificationCode: '',
                verificationType: 1 // 1:扫码 2:输入
            }
        };
    },
    created() {
        this.params.phone = this.$route.query.phone || this.$globalData.phone1;
        this.getCameras();
    },
    beforeDestroy() {
        this.stop();
    },
    methods: {
        // 打开输入验券码弹框
        inputCode() {
            this.params.verificationCode = '';
            this.show = true;
        },
        // 确认输入验券码
        dialogConfirm() {
            this.params.verificationType = 2;
            this.writeOff();
        },
        // 获取相机
        getCameras() {
            Html5Qrcode.getCameras()
                .then((devices) => {
                    if (devices && devices.length) {
                        this.html5QrCode = new Html5Qrcode('reader');
                        this.html5QrCode
                            .start(
                                { facingMode: 'environment' },
                                {
                                    fps: 1,
                                    qrbox: { width: 250, height: 250 }
                                },
                                (decodedText, decodedResult) => {
                                    this.params.verificationCode = decodedText;
                                    this.params.verificationType = 1;
                                    this.writeOff();
                                }
                            )
                            .catch((err) => {
                                this.$toast.fail(JSON.stringify(err));
                            });
                    }
                })
                .catch(() => {
                    this.html5QrCode = new Html5Qrcode('reader');
                    this.$toast.fail('您需要授予相机访问权限');
                });
        },
        // 关闭相机
        stop() {
            if (!this.html5QrCode) return;
            this.html5QrCode
                .stop()
                .then((ignore) => {
                    // QR Code scanning is stopped.
                    console.log('QR Code scanning stopped.');
                })
                .catch(() => {
                    // Stop failed, handle it.
                    console.log('Unable to stop scanning.');
                });
            this.html5QrCode = null;
        },
        writeOff() {
            console.log(this.params);
            reqWriteOff(this.params)
                .then((res) => {
                    if (res.code === 200) {
                        this.$toast.success('核销成功!');
                    } else {
                        this.$toast.fail(res.data);
                    }
                })
                .catch(() => {
                    this.$toast.fail('服务器出现错误，请稍后再试！');
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.scan-confirmation {
    position: absolute;
    width: 100%;
    height: 100%;

    background-color: rgba(255, 255, 255, 0.8);

    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
}
.qrcode {
    position: relative;
    height: 100vh;
    width: 100vw;
    background: rgba($color: #000000, $alpha: 0.6);
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    .scan-title {
        text-align: center;
        font-size: 18px;
        color: #ffffff;
    }

    #reader {
        min-height: 300px;
        //  top: 50%;
        //  left: 0;
        //   transform: translateY(-50%);
    }

    .scan-input {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 300px;
        height: 40px;
        background: #ff6633;
        border-radius: 3px;
        color: #fff;
        font-size: 15px;
        margin: 0 auto;
    }

    .c2 {
        background: #ffffff;
        border: 1px solid #ff6633;
        border-radius: 3px;
        margin: 15px;
    }
}
</style>
